import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {ExtensionCategory} from '../../../../functions/src/types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {UserService} from '../../services/user.service';
import {RSValidatorFormDirective} from '../../../libs/rsvalidator/rsvalidator.directive';
import {AvailableIcon, IconsService} from '../../services/icons.service';
import {ReplaySubject, Subject} from 'rxjs';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  category: ExtensionCategory = {} as ExtensionCategory;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;

  /** list filtered by search keyword */
  public filteredIcons: ReplaySubject<AvailableIcon[]> = new ReplaySubject<AvailableIcon[]>(1);

  /** Subject that emits when the component has been destroyed. */
  iconSearch = '';

  constructor(private userService: UserService, public iconService: IconsService) {
    super();

    // Wait for input
    this.dialogValuesUpdated.subscribe(v => {
      this.updateCategory(v.category);
    });
    this.updateCategory({});
  }

  ngOnInit(): void {
    this.filterIcons();
  }

  ngOnDestroy() {
    this.filteredIcons.complete();
  }

  filterIcons() {
    // get the search keyword
    let search = this.iconSearch;
    if (!search) {
      this.filteredIcons.next(this.iconService.availableIcons.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredIcons.next(
      this.iconService.availableIcons.filter(
          icon => icon.name.toLowerCase().indexOf(search) > -1 ||
                  icon.tags.find(t => t.toLowerCase().indexOf(search) > -1))
    );

  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  updateCategory(input: any) {
    this.category = {
      id: input.id || null,
      color: input.color || Math.floor(Math.random() * 16777215).toString(16),
      icon: input.icon || null,
      name: input.name || null,
      archived: input.archived || false,
    } as ExtensionCategory;
    console.log('AddCategoryComponent::: ', this.category);
  }

  close() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  saveCategory() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.dialogValues.category = this.category;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
